import React from 'react'
import Tada from "react-reveal/Tada";

const Footer = () => {
  return (
    <>
    <div className="footer pb-3 ms-3">
          <Tada>
            <h4 className="text-center">
              Made With
              <a
                className="text-underline"
                style={{ color: "#25d366" }}
                href="https://www.facebook.com/bipromondal07"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bipro Mondal
              </a>
              &copy;2022- {new Date().getFullYear()}
            </h4>
          </Tada>
        </div>
    
    </>
  )
}

export default Footer